<script setup lang="ts">
import {
    Download,
    MousePointerClick,
    Link2,
    Table,
    PenLine,
    ChevronRight,
} from 'lucide-vue-next';
import type { LucideIcon } from 'lucide-vue-next';

type Step = { label: string; icon: LucideIcon };

const steps: Step[] = [
    { label: 'Import', icon: Download },
    { label: 'Tri', icon: MousePointerClick },
    { label: 'Association', icon: Link2 },
    { label: 'Extraction', icon: Table },
    { label: 'Rédaction', icon: PenLine },
];
</script>

<template>
    <div
        class="mx-auto flex max-w-2xl flex-wrap items-center justify-center gap-x-5 gap-y-4 rounded-2xl border border-border/60 bg-card/60 px-4 py-4 backdrop-blur-sm sm:gap-x-2"
    >
        <template v-for="(step, i) in steps" :key="step.label">
            <div class="flex flex-col items-center gap-1.5">
                <span
                    class="flex h-10 w-10 items-center justify-center rounded-xl border border-brand/20 bg-brand/10 text-brand"
                >
                    <component :is="step.icon" class="h-4.5 w-4.5" />
                </span>
                <span
                    class="text-[11px] font-medium text-foreground sm:text-xs"
                >
                    {{ step.label }}
                </span>
            </div>

            <div
                v-if="i < steps.length - 1"
                class="flow-x mb-5 hidden items-center sm:flex"
                aria-hidden="true"
            >
                <ChevronRight
                    v-for="c in 2"
                    :key="c"
                    class="h-3.5 w-3.5 text-orange-400"
                />
            </div>
        </template>
    </div>
</template>

<style scoped>
.flow-x > * {
    margin-left: -2px;
}

@media (prefers-reduced-motion: no-preference) {
    .flow-x > * {
        animation: flow-x 1.6s ease-in-out infinite;
    }

    .flow-x > *:nth-child(2) {
        animation-delay: 0.2s;
    }

    @keyframes flow-x {
        0% {
            opacity: 0.2;
            transform: translateX(-2px);
        }
        50% {
            opacity: 1;
        }
        100% {
            opacity: 0.2;
            transform: translateX(2px);
        }
    }
}
</style>
